/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@/shadcnComponents/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/shadcnComponents/ui/card";
import { Input } from "@/shadcnComponents/ui/input";
import { Label } from "@/shadcnComponents/ui/label";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shadcnComponents/ui/select";
import { Select } from "@radix-ui/react-select";
import { GoPlus } from "react-icons/go";
import { TbCamera } from "react-icons/tb";
import { Cropper, ReactCropperElement } from "react-cropper";
import { useStaticData } from "@/Providers/Data";
import { useEffect, useRef, useState } from "react";
import { useGeneralSettings } from "@/Providers/General";
import { TagsField1 } from "@/Components/Fields";
import { useCookies } from "react-cookie";
import { useInfluencer } from "@/Providers/Influencer";
import { useAuth } from "@/Providers/Auth";
import { useToast } from "@/shadcnComponents/ui/use-toast";
import mixpanel from "mixpanel-browser";
import { PhoneInput } from "@/shadcnComponents/ui/phone-input";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@/shadcnComponents/ui/input-otp";
import { IoMdOpen } from "react-icons/io";
import { CalendarIcon, FileText } from "lucide-react";
import * as XLSX from "xlsx";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shadcnComponents/ui/dialog";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcnComponents/ui/popover";
import { Calendar } from "@/shadcnComponents/ui/calendar";
import { format } from "date-fns";
import { OpenInNewWindow } from "@/Helpers/helper";

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface profileDataProps {
  linkTreeLink: string;
  whatsappLink: string;
  YouTubeLink: string;
  name: string;
  tagline: string;
  linkedinLink: string;
  twitterLink: string;
  instaLink: string;
  gender: string;
  fbLink: string;
  telegramLink: string;
  coverPhoto: string;
  profile: string;
  websiteLink: string;
  followers: {
    linktree: any;
    whatsapp: any;
    youTube: any;
    linkedin: number | null;
    twitter: number | null;
    fb: number | null;
    telegram: number | null;
    insta: number | null;
    website: number | null;
  };
  location: {
    country: string | null;
    state: string | null;
    city: string | null;
  };
  dob: Date;
}
export interface profileDataFormProps {
  data: profileDataProps;
  setData: React.Dispatch<React.SetStateAction<profileDataProps>>;
  formOneImages?: string[];
  setFormOneImages?: React.Dispatch<React.SetStateAction<string[]>>;
  errorArray?: [];
  onSubmit?: any;
  code?: number;
  setCode?: React.Dispatch<React.SetStateAction<number>>;
}
export const ProfileForm: React.FC<profileDataFormProps> = ({
  data,
  setData,
  formOneImages,
  setFormOneImages,
  // errorArray,
  onSubmit,
  code,
  setCode,
}) => {
  const authState = useAuth();
  const [openCropModal, setOpenCropModal] = useState({
    value: false,
    index: null,
  });
  const [image, setImage] = useState(null);
  const cropperRef = useRef<ReactCropperElement>(null);

  const generalState = useGeneralSettings();

  const onSaveImage = () => {
    const cropper = cropperRef.current?.cropper;
    setFormOneImages((prev) => {
      const newArr = [...prev];
      newArr[openCropModal?.index] = cropper?.getCroppedCanvas()?.toDataURL();
      return newArr;
    });
    setImage(null);
  };
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const handleCodeChange = (e) => {
    setCode(e.target.value);
  };
  const handleChangeImage = (index) => {
    const input = document.createElement("input");
    input.type = "file";

    input.onchange = (e: any) => {
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result as any);
        setOpenCropModal({ value: true, index: index });
      };
      reader.readAsDataURL(files[0]);
    };
    input.click();
  };
  return (
    <>
      <Card className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] ">
        <CardHeader className=" gap-[0px] ">
          <CardTitle className=" text-[#FFFFFF] text-[14px] md:text-[16px] flex">
            <span>
              Profile Information <br />{" "}
              <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
                {" "}
                👩🏻‍💻 Tell us a little more about you
              </span>
            </span>
            <div className="ml-auto text-[16px] md:text-[20px]  font-[500] flex items-center justify-center md:gap-[4px] ">
              <img
                className=" w-[24px] md:w-[32px] h-[24px] md:h-[32px] "
                src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
                alt=""
              />
              {generalState.SidebarChipsCount.profile +
                generalState.SidebarChipsCount.collab +
                generalState.SidebarChipsCount.monetization +
                generalState.SidebarChipsCount.content +
                generalState.SidebarChipsCount.audience +
                generalState.SidebarChipsCount.charges +
                generalState.SidebarChipsCount.referral || 0}
              {"  "}
              <span className=" ml-[2px] text-[14px] md:text-[16px] ">
                chips
              </span>
            </div>{" "}
          </CardTitle>
          <CardDescription className=" text-[#A3A3A3] font-inter text-[14px] flex items-center mt-0 "></CardDescription>
        </CardHeader>
        <CardContent>
          <form className="gap-[20px] flex flex-col">
            {/* profile piture */}
            <section className="flex w-[95px] h-[95px] rounded-full relative flex-col items-start gap-3 z-10">
              {formOneImages[1] ?? data?.profile ? (
                <>
                  <img
                    src={formOneImages[1] ?? data?.profile}
                    alt=""
                    className="w-full h-full bg-[#A6A6A6] rounded-full"
                  />
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      handleChangeImage(1);
                    }}
                    className=" text-[#FFFFFF]  absolute z-10 bottom-0 right-0 rounded-full bg-[#A6A6A6] cursor-pointer  "
                    color="#FFFFFF"
                  >
                    <GoPlus size={22} />
                  </span>
                </>
              ) : (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleChangeImage(1);
                  }}
                  className="border bg-[#2f3031] text-[#FFFFFF] border-[#A6A6A6] rounded-full w-full h-full flex items-center justify-center flex-col"
                >
                  <TbCamera />
                  <span className=" text-[12px] ">Add a photo</span>
                </button>
              )}
            </section>
            <div className="flex flex-col w-full items-center gap-4 text-[#A3A3A3] ">
              {/* name and gender */}
              <div className="flex w-full gap-[12px] ">
                <div className="flex w-full flex-col ">
                  {/* <Label htmlFor="name">Name</Label> */}
                  <Input
                    value={data?.name}
                    onChange={handleChange}
                    name="name"
                    id="name"
                    // error={errorArray?.includes("name")}
                    className=" bg-transparent placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                    placeholder="Ravi Ahirwar"
                  />
                </div>
                <div className="flex w-full flex-col  ">
                  {/* <Label htmlFor="framework">Framework</Label> */}
                  <Select
                    onValueChange={(value) => {
                      setData((prevData) => {
                        return { ...prevData, gender: value };
                      });
                    }}
                    defaultValue={data.gender?.toString()}
                    value={data.gender?.toString()}
                  >
                    <SelectTrigger
                      className="bg-transparent text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                      id="gender"
                    >
                      <SelectValue placeholder="Select Gender" />
                    </SelectTrigger>
                    <SelectContent
                      className=" border-[#262626]"
                      position="popper"
                    >
                      <SelectItem value="Male">Male</SelectItem>
                      <SelectItem value="Female">Female</SelectItem>
                      <SelectItem value="Rather not to say">
                        Rather not to say
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              {/* Date of Birth */}
              <div className="w-full flex flex-col space-y-1.5">
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      className="bg-transparent text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 justify-start text-left font-normal"
                    >
                      {data?.dob ? (
                        format(data.dob, "PPP")
                      ) : (
                        <span className="text-[#A3A3A3]">Date of Birth</span>
                      )}
                      <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent
                    className="w-auto p-0 border border-[#363636]"
                    align="start"
                  >
                    <Calendar
                      className="rounded-lg shadow-lg"
                      mode="single"
                      selected={data?.dob}
                      onSelect={(date) => {
                        setData((prevData) => {
                          return { ...prevData, dob: date };
                        });
                      }}
                      initialFocus
                      disabled={(date) => date > new Date()}
                      captionLayout="dropdown-buttons"
                      fromYear={1900}
                      toYear={new Date().getFullYear()}
                    />
                  </PopoverContent>
                </Popover>
              </div>
              {/* tagline */}
              <div className="flex w-full flex-col space-y-1.5">
                {/* <Label htmlFor="name">Name</Label> */}
                <Input
                  className=" bg-transparent placeholder:text-[#A3A3A3] text-[12px] md:text-[14px] placeholder:text-[12px] md:placeholder:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0  "
                  placeholder="Your tagline"
                  value={data?.tagline}
                  onChange={handleChange}
                  name="tagline"
                  id="tagline"
                />
              </div>
              <span className="w-full h-[0px] bg-[#1A1A1A] "></span>
            </div>
          </form>
          <div className="w-full mt-[20px] ">
            <div className="flex w-full flex-col space-y-1.5">
              <Label
                className="text-[#A3A3A3] text-[12px] md:text-[14px] "
                htmlFor="code"
              >
                Enter referral Code
              </Label>
              <Input
                value={code}
                onChange={handleCodeChange}
                name="code"
                id="code"
                className=" bg-transparent text-[#A3A3A3] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                placeholder=""
                disabled={
                  authState?.loggedUser?.refered_by?.toString?.length > 0
                }
              />
            </div>
          </div>
        </CardContent>
        <CardFooter className="flex md:justify-end">
          <Button
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
            className="bg-[#DC2627] hover:bg-[#dc2644] w-full md:w-auto"
          >
            Save & Continue
          </Button>
        </CardFooter>
      </Card>
      {openCropModal?.value && (
        <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-20 bg-[#eeeeee7b]">
          <div className="flex flex-col items-center gap-3">
            <Cropper
              ref={cropperRef}
              style={{ height: 400, width: "100%" }}
              initialAspectRatio={openCropModal?.index === 0 ? 3 / 1 : 1}
              src={image}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
              guides={true}
              movable={false}
              cropBoxResizable={false}
              toggleDragModeOnDblclick={false}
            />

            <button
              className="px-5 py-3 bg-red-600 text-white rounded"
              onClick={() => {
                setOpenCropModal({ value: false, index: null });
                onSaveImage();
              }}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export interface contentDataProps {
  categories: [];
  formats: [];
}
export interface contentFormProps {
  data: contentDataProps;
  setData: React.Dispatch<React.SetStateAction<contentDataProps>>;
  errorArray?: [];
  limit?: number;
  onSubmit?: any;
}
export const ContentForm: React.FC<contentFormProps> = ({
  data,
  setData,
  onSubmit,
}) => {
  const staticData = useStaticData();
  const generalState = useGeneralSettings();

  const [ContentTypeData, setContentTypeData] = useState<[] | undefined>();
  const [ContentFormatData, setContentFormatData] = useState<[] | undefined>();

  useEffect(() => {
    staticData?.getNewDataFromType("Content Type").then((e) => {
      setContentTypeData(e);
    });
  }, []);
  useEffect(() => {
    staticData?.getNewDataFromType("Content Format").then((e) => {
      setContentFormatData(e);
    });
  }, []);

  return (
    <Card className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] gap-[20px] ">
      <CardHeader className=" gap-[0px] ">
        <CardTitle className=" text-[#FFFFFF] text-[14px] md:text-[16px] flex">
          <span>
            Showcase Your Content Expertise & Style <br />{" "}
            <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
              {" "}
              👩🏻‍💻 Help us understand your voice, format, and niche
            </span>
          </span>
          <div className="ml-auto text-[16px] md:text-[20px]  font-[500] flex items-center justify-center md:gap-[4px] ">
            <img
              className=" w-[24px] md:w-[32px] h-[24px] md:h-[32px] "
              src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
              alt=""
            />
            {generalState.SidebarChipsCount.profile +
              generalState.SidebarChipsCount.collab +
              generalState.SidebarChipsCount.monetization +
              generalState.SidebarChipsCount.content +
              generalState.SidebarChipsCount.audience +
              generalState.SidebarChipsCount.charges +
              generalState.SidebarChipsCount.referral || 0}{" "}
            <span className=" ml-[2px] text-[14px] md:text-[16px] ">chips</span>
          </div>{" "}
        </CardTitle>
        <CardDescription className=" text-[#A3A3A3] text-[14px] flex items-center mt-0 "></CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-[40px] ">
        <div className="flex flex-col gap-[12px]">
          <span className="text-[#E2E8F0] text-[12px] md:text-[14px] ">
            Select your niche content categories (MAX 6)
          </span>
          <div className="flex flex-wrap gap-[12px]">
            <TagsField1
              data={ContentTypeData ?? []}
              values={data?.categories}
              setValues={(value: []) => {
                data?.categories?.length < 6 &&
                  setData({ ...data, categories: value });
              }}
              limit={6}
              tagName={"categoryName"}
            />
          </div>
        </div>
        <div className="flex flex-col gap-[12px]">
          <span className="text-[#E2E8F0] text-[12px] md:text-[14px] font-[400] ">
            Give brands a glimpse into your style (SELECT ALL THAT APPLY)
          </span>
          <div className="flex flex-wrap gap-[12px]">
            <TagsField1
              data={ContentFormatData ?? []}
              values={data?.formats}
              setValues={(value: []) => {
                setData({ ...data, formats: value });
              }}
              limit={6}
              tagName={"contentFormatName"}
            />
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex md:justify-end">
        <Button
          onClick={(e) => {
            e.preventDefault();
            onSubmit();
          }}
          className="bg-[#DC2627] w-full md:w-auto hover:bg-[#dc2644] "
        >
          Save & Continue
        </Button>
      </CardFooter>
    </Card>
  );
};

export interface audienceDataProps {
  types: [];
  platforms: [
    {
      platform: string;
      audience: number | null;
      link: string;
    }
  ];
}

export interface verificationDataProps {
  email: string;
  mobile: string;
}
export interface verificationDataFormProps {
  data: verificationDataProps;
  setData: React.Dispatch<React.SetStateAction<verificationDataProps>>;
  onSuccess: () => void;
  errorArray?: [];
}
export const VerificationDataForm: React.FC<verificationDataFormProps> = ({
  data,
  setData,
  onSuccess,
}) => {
  const [cookies, setCookie] = useCookies();
  const generalState = useGeneralSettings();
  const influencerState = useInfluencer();
  const authState = useAuth();
  const { toast } = useToast();
  const [openOtpCode, setOpenOtpCode] = useState(false);
  const [otp, setotp] = useState("");

  useEffect(() => {
    if (authState?.loggedUser?.email?.length > 1) {
      setData((prevData) => {
        return { ...prevData, email: authState?.loggedUser?.email };
      });
    }
  }, []);
  const handleChangeData = (value: string, field: string) => {
    setData((prevData) => {
      return { ...prevData, [field]: value };
    });
  };
  const saveDetails = async () => {
    generalState?.setLoading(true);
    mixpanel.track("Save Details anchors collab");
    try {
      if (!data?.email) {
        generalState?.setLoading(false);
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please Enter Email.",
        });
        return;
      } else if (!data?.mobile) {
        generalState?.setLoading(false);
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please Enter Mobile number.",
        });
        return;
      } else if (data?.mobile?.length < 8) {
        generalState?.setLoading(false);
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Enter a proper mobile number.",
        });
        return;
      }

      const result = await influencerState?.SaveUserInfo(data);
      if (result.success) {
        authState?.setReFetchUserData((prev) => {
          return !prev;
        });
        generalState?.setLoading(false);

        sendOTP();
      } else {
        generalState?.setLoading(false);
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: result?.error,
        });
      }
    } catch (e) {
      generalState?.setLoading(false);
    }
  };
  const sendOTP = async () => {
    if (data?.mobile?.length > 4) {
      const json = await influencerState?.SentMessageFromSNS(
        data?.mobile ?? ""
      );

      if (json?.MessageID) {
        toast({
          title: "OTP sent successfully .",
        });
        const otpcode = parseInt(String(json?.code - 145626)) * 562002;
        setCookie("ccoondfe", otpcode, { maxAge: 120 }); // valid for  minute
        setOpenOtpCode(true);
      }
    } else {
      toast({
        variant: "destructive",
        title: "There was a problem with your request.",
        description: "Enter a proper mobile number",
      });
    }
  };
  const verifyOTP = async () => {
    mixpanel.track("Verify otp anchors collab");
    if (otp?.length !== 6) {
      toast({
        variant: "destructive",
        title: "Enter a proper code.",
      });
    } else {
      const code = cookies?.ccoondfe;
      if (!code) {
        toast({
          variant: "destructive",
          title: "OTP was valid for 2 minute, Please retry again.",
        });
      } else {
        if (parseInt(otp) === parseInt((parseInt(code) / 562002).toString())) {
          // Save the number in user info ----------
          const result = await influencerState?.SaveUserInfo({
            is_verified: true,
            status: 1,
          });

          if (result) {
            toast({
              variant: "default",
              title: "OTP VERIFICATION SUCCESSFUL.",
            });
            onSuccess();
          } else {
            toast({
              variant: "destructive",
              title: "Some error occurred in verification.",
            });
          }
        } else {
          toast({
            variant: "destructive",
            title: "Invalid OTP!!!. Try again!!!",
          });
        }
      }
    }
  };
  return (
    <Card className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] gap-[20px] ">
      <CardHeader className=" gap-[0px] ">
        <CardTitle className=" text-[#FFFFFF] text-[14px] md:text-[16px] flex">
          <span>
            Please confirm your contact details <br />{" "}
            <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
              {" "}
              This is where the brands will connect with you for collaborations
            </span>
          </span>
        </CardTitle>
        <CardDescription className=" text-[#A3A3A3] text-[14px] flex items-center mt-0 "></CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-[40px] ">
        <div className="grid w-full items-center gap-[20px] text-[#A3A3A3]">
          <div className="flex gap-[12px] ">
            <div className="flex w-full md:w-1/2 text-[12px] md:text-[14px] flex-col space-y-1.5">
              <Label className="text-[12px] md:text-[14px]" htmlFor="email">
                Email
              </Label>
              <Input
                value={data?.email}
                onChange={(e) =>
                  handleChangeData(e.target.value, e.target.name)
                }
                name="email"
                id="email"
                className=" bg-transparent placeholder:text-[#A3A3A3] text-[12px] md:text-[14px] placeholder:text-[12px] md:placeholder:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
              />
            </div>
          </div>

          <div className="flex  w-full text-[12px] md:text-[14px] md:w-1/2 flex-col space-y-1.5">
            <Label className="text-[12px] md:text-[14px]" htmlFor="phone ">
              Contact Number (Preferably Whatsapp)
            </Label>
            <PhoneInput
              value={data?.mobile}
              defaultCountry="IN"
              id="phone"
              className="bg-transparent placeholder:text-[#A3A3A3]  text-[12px] md:text-[14px] placeholder:text-[12px] md:placeholder:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0"
              onChange={(e) => {
                setData((prevData) => {
                  return { ...prevData, mobile: e };
                });
              }}
            />
          </div>
          {openOtpCode && (
            <div className="flex w-full md:w-1/2  flex-col space-y-1.5">
              <Label className="text-[12px] md:text-[14px]" htmlFor="phone">
                OTP sent on {data?.mobile}
              </Label>
              <InputOTP
                className=" border-[#262626] "
                value={otp}
                onChange={(value) => setotp(value)}
                maxLength={6}
              >
                <InputOTPGroup>
                  <InputOTPSlot
                    color="white"
                    className="border-[#262626]"
                    index={0}
                  />
                  <InputOTPSlot
                    color="white"
                    className="border-[#262626]"
                    index={1}
                  />
                  <InputOTPSlot
                    color="white"
                    className="border-[#262626]"
                    index={2}
                  />
                </InputOTPGroup>
                <InputOTPSeparator />
                <InputOTPGroup>
                  <InputOTPSlot
                    color="white"
                    className="border-[#262626]"
                    index={3}
                  />
                  <InputOTPSlot
                    color="white"
                    className="border-[#262626]"
                    index={4}
                  />
                  <InputOTPSlot
                    color="white"
                    className="border-[#262626]"
                    index={5}
                  />
                </InputOTPGroup>
              </InputOTP>
            </div>
          )}
        </div>
      </CardContent>
      <CardFooter className="flex md:justify-start">
        <Button
          onClick={(e) => {
            e.preventDefault();
            openOtpCode ? verifyOTP() : saveDetails();
          }}
          className="bg-[#DC2627] hover:bg-[#dc2644] w-full md:w-auto"
        >
          Continue
        </Button>
      </CardFooter>
    </Card>
  );
};

export interface chargesDataProps {
  PostMaxPrice: number;
  PostMinPrice: number;
  MonthlyNumberOfPost: number;
  MonthlyMaxPrice: number;
  MonthlyMinPrice: number;
  YearlyNumberOfPost: number;
  YearlyMaxPrice: number;
  YearlyMinPrice: number;
  AcceptFreeBies: boolean;
  isNegotiable: boolean;
}
export interface collabDataProps {
  companyName: string;
  companyUrl: string;
  companyProfile: string;
  goals: [];
  postLink: string;
}
export interface monetizationDataProps {
  platformName: string;
  profileLink: string;
  methods: [];
  paidAudience: number | null;
}

export interface MediaKitSheetProps {
  DEMOGRAPHICS: any[];
  DISCOVERY: any[];
  ENGAGEMENT: any[];
  FOLLOWERS: any[];
  TOPPOSTS: any[];
}

export interface MediaKitFormProps {
  data: MediaKitSheetProps;
  setData: React.Dispatch<React.SetStateAction<MediaKitSheetProps>>;
  onSubmit?: () => void;
  onSkip?: () => void;
}

const isValidDate = (dateString: string) => {
  const datePattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  return datePattern.test(dateString);
};

export const CreateMediaKitForm: React.FC<MediaKitFormProps> = ({
  data,
  setData,
  onSubmit,
  onSkip,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const { toast } = useToast();

  const generalState = useGeneralSettings();
  const influencerState = useInfluencer();

  const requiredSheets = [
    "DISCOVERY",
    "ENGAGEMENT",
    "TOP POSTS",
    "FOLLOWERS",
    "DEMOGRAPHICS",
  ];
  const requiredHeaders = {
    DISCOVERY: ["Overall Performance", "DATE_PLACEHOLDER"],
    ENGAGEMENT: ["Date", "Impressions", "Engagements"],
    TOPPOSTS: [
      "Post URL",
      "Post publish date",
      "Engagements",
      "Post URL",
      "Post publish date",
      "Impressions",
    ],
    FOLLOWERS: ["Date", "New followers"],
    DEMOGRAPHICS: ["Top Demographics", "Value", "Percentage"],
  };

  const validateSheetHeaders = (sheetName: string, headers: any[]) => {
    const requiredSheetHeaders = requiredHeaders[sheetName];
    const errors: string[] = [];

    // Specific logic for DISCOVERY sheet
    if (sheetName === "DISCOVERY") {
      if (headers.length < 2) {
        errors.push(`${sheetName}: Fewer headers than required.`);
      } else if (headers[0] !== "Overall Performance") {
        errors.push(
          `${sheetName}: First header must be 'Overall Performance'.`
        );
      } else if (!isValidDate(headers[1]?.split(" - ")[0])) {
        errors.push(`${sheetName}: Second header must be a valid date.`);
      }
      return errors;
    }

    if (headers.length < requiredSheetHeaders.length) {
      errors.push(`${sheetName}: Fewer headers than required.`);
    } else if (headers.length > requiredSheetHeaders.length) {
      errors.push(`${sheetName}: More headers than required.`);
    }

    const headersMatch = headers.every((header, index) => {
      if (requiredSheetHeaders[index] === "DATE_PLACEHOLDER") {
        return isValidDate(header); // Check if the header is a valid date when it's a date placeholder
      }
      return header === requiredSheetHeaders[index];
    });

    if (!headersMatch) {
      errors.push(`${sheetName}: Headers do not match the required headers.`);
    }

    return errors;
  };

  const handleValidation = (
    sheetNames: string[],
    sheetsData: MediaKitSheetProps
  ): string[] => {
    const errors: string[] = [];

    // Case 1: Fewer sheets than required
    if (sheetNames.length < requiredSheets.length) {
      errors.push("The workbook has fewer sheets than required.");
    }

    // Case 2: More sheets than required
    if (sheetNames.length > requiredSheets.length) {
      errors.push("The workbook has more sheets than required.");
    }

    // Case 3: Check if all required sheets are present
    const missingSheets = requiredSheets.filter(
      (requiredSheet) => !sheetNames.includes(requiredSheet)
    );
    if (missingSheets.length > 0) {
      errors.push(
        `The workbook is missing required sheets: ${missingSheets.join(", ")}`
      );
    }

    // Case 4-6: Validate headers for each sheet
    sheetNames.forEach((sheetName) => {
      if (sheetName === "TOP POSTS") sheetName = "TOPPOSTS";
      if (requiredHeaders[sheetName]) {
        const sheetData = sheetsData[sheetName];
        const headers =
          sheetName === "TOPPOSTS" || sheetName === "FOLLOWERS"
            ? sheetData[2]?.filter((item) => item) || []
            : sheetData[0] || [];
        const headerErrors = validateSheetHeaders(sheetName, headers);
        errors.push(...headerErrors);
      }
    });

    return errors;
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const uploadExcelCsvFileToS3 = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    const result = await influencerState?.uploadInfluencerLinkedinData(
      formData
    );
    return result;
  };

  const handleOnSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (file) {
      const reader = new FileReader();

      reader.onload = async (event: any) => {
        const binaryStr = event.target.result;

        // Parse the Excel file
        const workbook = XLSX.read(binaryStr, { type: "binary" });

        // Initialize an object to store data from all sheets
        const allSheetsData: MediaKitSheetProps = data;

        // Iterate through each sheet
        workbook.SheetNames.forEach((sheetName) => {
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          if (sheetName === "TOP POSTS") sheetName = "TOPPOSTS";
          allSheetsData[sheetName] = jsonData;
        });

        // Validate sheets and headers
        const errors = handleValidation(workbook.SheetNames, allSheetsData);

        if (errors.length === 0) {
          // Upload the file to S3 after successful validation
          const uploadResult = await uploadExcelCsvFileToS3(file);
          if (uploadResult.success) {
            setData(allSheetsData);
            onSubmit();
          } else {
            toast({
              title: "Upload Failed",
              description: "Failed to upload File",
              variant: "destructive",
            });
          }
        } else {
          toast({
            title: "Error",
            description: errors.join(", "),
            variant: "destructive",
          });
        }
      };

      reader.readAsBinaryString(file);
    }
  };

  return (
    <Card className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] ">
      <CardHeader className=" gap-[0px]  px-4 ">
        <CardTitle className=" text-[#FFFFFF] text-[14px] md:text-[16px] flex flex-col">
          <div className="flex w-full ">
            <span>
              Create Media Kit <br />{" "}
              <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
                {" "}
                Import LinkedIn Data to create Media Kit
              </span>
            </span>
            <div className="ml-auto text-[16px] md:text-[20px]  font-[500] flex items-center justify-center md:gap-[4px] ">
              <img
                className=" w-[24px] md:w-[32px] h-[24px] md:h-[32px] "
                src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
                alt=""
              />
              {generalState.SidebarChipsCount.profile +
                generalState.SidebarChipsCount.collab +
                generalState.SidebarChipsCount.monetization +
                generalState.SidebarChipsCount.content +
                generalState.SidebarChipsCount.audience +
                generalState.SidebarChipsCount.charges +
                generalState.SidebarChipsCount.referral || 0}
              {"  "}
              <span className=" ml-[2px] text-[14px] md:text-[16px] ">
                chips
              </span>
            </div>{" "}
          </div>
          <div className="w-full flex items-center justify-end ">
            <Dialog>
              <DialogTrigger>
                <span className="flex items-center gap-1 text-[#DC2627] text-right text-xs not-italic font-normal leading-[normal] underline cursor-pointer">
                  Get LinkedIn Data <IoMdOpen />{" "}
                </span>
              </DialogTrigger>
              <DialogContent className="bg-[#1B1F23] border-none ">
                <DialogHeader className="flex items-center justify-center gap-2.5 ">
                  <DialogTitle className="text-white text-center text-base not-italic font-semibold leading-[normal] flex flex-col gap-2.5 ">
                    <span>How to get linkedIn Data</span>
                    <span className="text-neutral-400 text-center text-sm not-italic font-normal leading-[normal];">
                      Make sure your media is upto date!
                    </span>
                  </DialogTitle>
                  <DialogDescription>
                    <div className="flex flex-col gap-5 ">
                      <img
                        className="w-[200px]"
                        src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/ManualMediaKit.gif"
                        alt=""
                      />
                    </div>
                  </DialogDescription>
                </DialogHeader>
                <DialogFooter className="sm:justify-center">
                  <DialogClose asChild>
                    <Button
                      type="button"
                      variant="destructive"
                      className="bg-[#DC2627] "
                      onClick={() =>
                        OpenInNewWindow({
                          link: "https://www.linkedin.com/analytics/creator/content/?metricType=IMPRESSIONS&timeRange=past_7_days",
                        })
                      }
                    >
                      Open LinkedIn
                    </Button>
                  </DialogClose>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent className=" px-4 gap-2 flex items-center flex-col">
        <div className="flex w-full flex-col relative justify-center items-center gap-px border px-[90px] py-[22px] rounded-[5px] border-dashed border-[#666]">
          <FileText size={20} color="#666666" />
          <span className="text-slate-200 text-[10px] not-italic font-normal leading-[22px]">
            {file ? file?.name : "Select Excel/CSV File"}
          </span>
          <input
            type="file"
            id="excelFileInput"
            accept=".xlsx, .xls, .csv"
            onChange={handleOnChange}
            className="absolute inset-0 opacity-0 cursor-pointer"
          />
        </div>
        {file && (
          <Button variant="destructive" onClick={handleOnSubmit}>
            Submit
          </Button>
        )}
        {!file && (
          <div className="text-center flex w-full justify-end text-[14px] text-neutral-400 font-normal leading-[normal]">
            <Button
              className="py-[1px] h-[25px] "
              variant="destructive"
              onClick={onSkip}
            >
              Skip
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
